import React, { useEffect, useState } from "react";
import ProductListButton from "../../Button/ProductListButton";
import "./ProductFilterModal.css";

const ProductFilterModal = ({
  isOpen,
  onClose,
  fields,
  filters,
  setFilters,
  dropdownData,
  onDownloadFiltered,
  showDownloadButton = true,
}) => {
  const [tempFilters, setTempFilters] = useState({});
  const [isClosing, setIsClosing] = useState(false);

  useEffect(() => {
    const initial = {};
    fields.forEach((f) => {
      if (f.type === "date") {
        initial[`${f.fields}_from`] = filters[`${f.fields}_from`] || "";
        initial[`${f.fields}_to`] = filters[`${f.fields}_to`] || "";
      } else {
        initial[f.fields] = filters[f.fields] || "";
      }
    });
    setTempFilters(initial);
  }, [filters, isOpen]);

  const triggerClose = () => {
    setIsClosing(true);
    setTimeout(() => {
      setIsClosing(false);
      onClose();
    }, 400);
  };

  const handleSubmit = () => {
    setFilters(tempFilters);
    triggerClose();
  };

  const handleClear = () => {
    const cleared = {};
    fields.forEach((f) => {
      if (f.type === "date") {
        cleared[`${f.fields}_from`] = "";
        cleared[`${f.fields}_to`] = "";
      } else {
        cleared[f.fields] = "";
      }
    });
    setTempFilters(cleared);
    setFilters(cleared);
    triggerClose();
  };

  if (!isOpen && !isClosing) return null;

  return (
    <div className="filter-modal__overlay" onClick={triggerClose}>
      <div
        className={`filter-modal__panel ${
          isClosing ? "filter-modal__panel--closing" : ""
        }`}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="filter-modal__header">
          <h2 className="filter-modal__title">Filter Table</h2>
          <button className="filter-modal__close-button" onClick={triggerClose}>
            ✖
          </button>
        </div>

        {/* Body */}
        <div className="filter-modal__body">
          {fields.map((field) => (
            <div className="filter-modal__field" key={field.fields}>
              <label className="filter-modal__label">
                {field.fields
                  .replace(/([A-Z])/g, " $1")
                  .replace(/^./, (str) => str.toUpperCase())}
              </label>

              {field.type === "date" ? (
                <div className="filter-modal__date-range">
                  <input
                    className="filter-modal__input"
                    type="date"
                    value={tempFilters[`${field.fields}_from`] || ""}
                    onChange={(e) =>
                      setTempFilters((prev) => ({
                        ...prev,
                        [`${field.fields}_from`]: e.target.value,
                      }))
                    }
                  />
                  <span>to</span>
                  <input
                    className="filter-modal__input"
                    type="date"
                    value={tempFilters[`${field.fields}_to`] || ""}
                    onChange={(e) =>
                      setTempFilters((prev) => ({
                        ...prev,
                        [`${field.fields}_to`]: e.target.value,
                      }))
                    }
                  />
                </div>
              ) : field.api ? (
                <select
                  className="filter-modal__select"
                  value={tempFilters[field.fields] || ""}
                  onChange={(e) =>
                    setTempFilters((prev) => ({
                      ...prev,
                      [field.fields]: e.target.value,
                    }))
                  }
                >
                  <option value="">All</option>
                  {Array.isArray(dropdownData[field.fields]) &&
                    dropdownData[field.fields].map((opt) => {
                      const value = opt?.id ?? opt?._id;
                      const label = String(
                        opt?.label ?? opt?.name ?? "Unnamed"
                      );
                      return (
                        <option key={value} value={value}>
                          {label}
                        </option>
                      );
                    })}
                </select>
              ) : (
                <input
                  className="filter-modal__input"
                  type={field.type === "number" ? "number" : "text"}
                  value={tempFilters[field.fields] || ""}
                  onChange={(e) =>
                    setTempFilters((prev) => ({
                      ...prev,
                      [field.fields]: e.target.value,
                    }))
                  }
                  placeholder={`Filter ${field.fields}`}
                />
              )}
            </div>
          ))}
        </div>

        {/* Footer */}
        <div className="filter-modal__footer">
          <ProductListButton
            label="Apply"
            icon="fas fa-check-circle"
            onClick={handleSubmit}
          />
          <ProductListButton
            label="Clear"
            icon="fas fa-broom"
            onClick={handleClear}
          />
          {showDownloadButton && (
            <ProductListButton
              label="Download"
              icon="fas fa-download"
              onClick={onDownloadFiltered}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default ProductFilterModal;
